import { Menu } from 'antd';
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';

const { getDataType } = ssCommonUtils;

class Content extends React.Component {
    constructor(props) { super(props); }
    render() {
        const { content, menuPadding } = this.props;
        return (
            <div 
                className='afsp-menu-content-container' 
                style={menuPadding == null && !isNaN(menuPadding) ? {} : { 
                    top: `${48 + menuPadding}px` 
                }}
            >{
                getDataType(content) === 'Function' 
                    ? content() 
                    : content
            }</div>
        );
    }
}

export default class extends React.Component {
    constructor(props) { super(props); }

    noramlizeMenuItems = menuItems => {
        const elements = [];
        for (let i in menuItems) 
            if (menuItems[i] != null) 
                elements.push(menuItems[i]);
        return elements;
    }

    render() {
        const 
        { activeKey, menu, onClick, menuPadding } = this.props,
        props = {...menu[activeKey], activeKey, menuPadding };
        
        return (
            <div>
                <Menu
                    selectedKeys={[ activeKey ]}
                    mode='horizontal'
                    onClick={onClick != null ? onClick : () => {/* No-op */}}
                    style={{ textAlign: 'center' }}
                >
                    {this.noramlizeMenuItems(Object.keys(menu).map(key => menu[key].hasOwnProperty('onCondition') ? !menu[key].onCondition() ? null : (
                        <Menu.Item key={key} disabled={menu[key].hasOwnProperty('disabled') ? menun[key].disabled : false}>
                            {menu[key].title}
                        </Menu.Item>
                    ) : (
                        <Menu.Item key={key} disabled={menu[key].hasOwnProperty('disabled') ? menun[key].disabled : false}>
                            {menu[key].title}
                        </Menu.Item>
                    )))}
                </Menu>
                {menu[activeKey].hasOwnProperty('onCondition') 
                    ? !menu[activeKey].onCondition() ? null : <Content {...props} />
                    : <Content {...props} />
                }
            </div>
        );
    }
}